import debug from 'debug';
import moment from 'moment';

const log = debug('sagas:storage-utils');

// storage utils
export function getStorage(storage, key) {
  try {
    const result = storage.getItem(key);
    log(`successfully retrieved from local storage. key: ${key}`);
    return result;
  } catch (e) {
    log(`could not retrieve item from local storage. key: ${key} error: ${e.message}`);
  }
}

export function setStorage(storage, key, value) {
  try {
    const result = storage.setItem(key, value);
    log(`successfully saved item in local storage. key: ${key}`);
    return result;
  } catch (e) {
    log(`could not save item to local storage. key: ${key} error: ${e.message}`);
  }
}

export function removeStorage(storage, key) {
  try {
    const result = storage.removeItem(key);
    log(`successfully cleared from local storage. key: ${key}`);
    return result;
  } catch (e) {
    log(`could not clear item from local storage. key: ${key} error: ${e.message}`);
  }
}

export function clearStorage(storage) {
  try {
    const result = storage.clear();
    log(`successfully cleared all local storage.`);
    return result;
  } catch (e) {
    log(`could not clear all from local storage. error: ${e.message}`);
  }
}

export function jsonParse(string) {
  try {
    return JSON.parse(string);
  } catch (e) {
    log('could not parse the stringified value: ' + e.message);
  }
}

export function jsonStringify(obj) {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    log('could not stringify the object: ' + e.message);
  }
}

export function getTimeout() {
  return jsonStringify({ timeout: moment().add(1, 'day').valueOf() });
}

// for a local storage key, check an expiration key to see if
// the data is expired. returns true if expired.
export function isKeyExpired(storage, key) {
  log(`checking expiration for key: ${key}`);

  const json = getStorage(storage, key);
  const obj = jsonParse(json);

  if (!obj) {
    log('no expiration obj found in storage');
    return false;
  }

  const { timeout } = obj;

  if (!timeout) {
    log('no timeout found in storage');
    return false;
  }

  const expirationMoment = moment(timeout);
  const hasExpired = expirationMoment.isBefore(moment());

  log(`stored value for ${key} ${hasExpired ? 'expired' : 'expires'} ${expirationMoment.fromNow()}`);

  return hasExpired;
}



// WEBPACK FOOTER //
// ./src/utils/storageHelpers.js